





































import { Component, Mixins, Emit } from 'vue-property-decorator'
import BaseIcon from 'vuecomponents/base_icon.vue'
import localStorage from 'bits/safe_storage'
import KeyboardTrapMixin from 'vuemixins/modal_keyboard_trap_mixin'
import { __ } from 'bits/intl'

@Component({
  components: {
    BaseIcon,
  },
})
export default class AccessibilityDropdown extends Mixins(KeyboardTrapMixin) {
  openModal!: (modalNodes: NodeList | Node[]) => void // from KeyboardTrapMixin
  closeModal!: () => void // from KeyboardTrapMixin
  isModalOpen!: boolean // from KeyboardTrapMixin
  highContrast = false

  get backdropClass(): object {
    return {
      show: this.isModalOpen,
      backdrop: true,
    }
  }

  get dialogClass(): object {
    return {
      show: this.isModalOpen,
      menu: true,
    }
  }

  @Emit('input')
  change(e): void {
    const checked = e.target.checked
    const body = document.getElementsByTagName('body')[0]

    // Enabling more color contrast for sign up button on homepage
    // Style located in home_app.vue
    if (checked) {
      body.classList.add('high-contrast')
      this.highContrast = true
      localStorage.setItem('highContrast', JSON.stringify(this.highContrast))
    } else {
      body.classList.remove('high-contrast')
      this.highContrast = false
      localStorage.setItem('highContrast', JSON.stringify(this.highContrast))
    }
  }

  mounted(): void {
    const highContrastValue = localStorage.getItem('highContrast')
    this.highContrast = highContrastValue ? JSON.parse(highContrastValue) : false

    if (this.highContrast) {
      this.setContrast()
    }
  }

  setContrast(): void {
    const body = document.getElementsByTagName('body')[0]

    if (body.classList.length == 0) {
      body.classList.add('high-contrast')
    }
  }

  handleModal(): void {
    // Find the modal and its focusable children
    const modal = document.querySelector('.menu') as HTMLElement
    const focusableElementsString = '.dialog-close, input[type=checkbox]'
    let modalNodes: NodeList | Node[] = modal.querySelectorAll(focusableElementsString)
    modalNodes = Array.from(modalNodes)

    this.openModal(modalNodes)
  }
}
